import React from 'react';
import { useTranslation } from 'react-i18next';
import DetailItem from './DetailItem';
import OriginalSize from './OriginalSize';
import { deviationHasFileSizeMetadata } from './helpers';
import s from './Default.scss';
export var DetailItemList = function (_a) {
    var _b, _c;
    var deviation = _a.deviation;
    var t = useTranslation().t;
    var exif = (_c = (_b = deviation === null || deviation === void 0 ? void 0 : deviation.extended) === null || _b === void 0 ? void 0 : _b.exif) !== null && _c !== void 0 ? _c : [];
    var hasDetails = exif.length > 0 || deviationHasFileSizeMetadata(deviation);
    if (!hasDetails) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s['detail-group-title'] }, t('deviation.details.camera')),
        React.createElement(OriginalSize, { deviation: deviation }),
        exif.map(function (_a) {
            var tag = _a.tag, value = _a.value;
            return (React.createElement(DetailItem, { key: tag, name: tag, value: value, transPrefix: "exif." }));
        })));
};
DetailItemList.displayName = 'DetailItemList';
export default DetailItemList;
//# sourceMappingURL=DetailItemList.js.map